var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.345 0.625854C4.924 0.625854 0.345001 5.20485 0.345001 10.6259C0.345001 16.0469 4.924 20.6259 10.345 20.6259C15.766 20.6259 20.345 16.0469 20.345 10.6259C20.345 5.20485 15.766 0.625854 10.345 0.625854ZM10.345 5.62585C12.072 5.62585 13.345 6.89785 13.345 8.62585C13.345 10.3539 12.072 11.6259 10.345 11.6259C8.619 11.6259 7.345 10.3539 7.345 8.62585C7.345 6.89785 8.619 5.62585 10.345 5.62585ZM5.239 15.3979C6.136 14.0779 7.632 13.1979 9.345 13.1979H11.345C13.059 13.1979 14.554 14.0779 15.451 15.3979C14.173 16.7659 12.36 17.6259 10.345 17.6259C8.33 17.6259 6.517 16.7659 5.239 15.3979Z",
    fill: "#1e293b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconBlack);
export default __webpack_public_path__ + "static/media/userIconBlack.8485ccab890927aa34028ee93ee92057.svg";
export { ForwardRef as ReactComponent };